import { inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, UrlTree } from '@angular/router';

import { Logger } from '../logger.service';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { FirebaseAuthService } from '../firebase/firebase-auth.service';


const log = new Logger('AuthenticationGuard');

// @Injectable({
//     providedIn: 'root'
// })
export const AuthenticationGuard: CanActivateFn = async (route, state) => {
    // export function canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | Promise<boolean> {
    //: boolean | UrlTree => {
    // const browsercheckService = inject(BrowsercheckService);
    const authService = inject(AuthenticationService);
    const router = inject(Router);
    const apiService = inject(ApiService);
    const firebaseAuthService = inject(FirebaseAuthService);
    const authenticationService = inject(AuthenticationService);
    // return new Promise((resolve, reject) => {
    // if (!browsercheckService.isBrowserAllowed()) {
    //     log.debug('Not an allowed browser, redirecting...');
    //     router.navigate(['/nobrowser'], { replaceUrl: true });
    //     return resolve(false);
    // }
    //return this.authenticationService.isAuthenticated();
    // return this.firebaseAuthService.getTokenId()
    // Promise.resolve().then(() => {
    try {
        const token = await firebaseAuthService.getTokenId();
        const e = await isLoggedin(authenticationService);
        if (e) {
            const user = (authenticationService.credentials) ? authenticationService.credentials?.username : 'no logged User';
            // matomoTracker.setUserId(user);
            // matomoTracker.setDocumentTitle("ngx-Matomo Test");
            return true;
        } else {
            router.navigate(['/login', state.url], { replaceUrl: true });
            return false;
        }
    } catch (err) {
        // }).catch(() => {
        router.navigate(['/login', state.url], { replaceUrl: true });
        return false;
    }
    // });
    // });
}

function isLoggedin(authenticationService: AuthenticationService): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Promise.resolve().then(() => {
            authenticationService.reloadCredentials();
            if (!authenticationService.isAuthenticated()) {
                return Promise.resolve(false);
            } else {
                return Promise.resolve(true);
            }
        }).then((res) => {
            return resolve(res); // res;
        });
    });
}
